import type { ClientAnalyticsProvider, ServerAnalyticsProvider } from "@/lib/analytics/types";

export class NullServerProvider implements ServerAnalyticsProvider {
  async track(): Promise<void> {}
  async identify(): Promise<void> {}
  async flush(): Promise<void> {}
}

export class NullClientProvider implements ClientAnalyticsProvider {
  track(): void {}
  identify(): void {}
  page(): void {}
  reset(): void {}
}

export const nullServerProvider = new NullServerProvider();
export const nullClientProvider = new NullClientProvider();
